import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';

const categoryUrls = {
    'match-3': 'https://html5games.com/Match-3/a0732787-677c-4ff9-9ef5-73a21ff26f64',
    'bubble-shooter': 'https://html5games.com/Bubble-Shooter/09a8f220-955e-4114-a189-175faa5f1374',
    puzzle: 'https://html5games.com/Puzzle/af2ebd26-0786-423b-90da-ffb229840819',
    quiz: 'https://html5games.com/Quiz/8e0b96cd-0fed-4354-a43d-ae4785a798fd',
    cards: 'https://html5games.com/Cards/b32b5c79-362e-42a2-8a72-96f0ffe24bbb',
    girls: 'https://html5games.com/Girls/018103c4-e4a9-4b0e-86c1-5cc6782053ca',
    'jump-and-run': 'https://html5games.com/Jump-Run/8a2ce06d-c47f-4eec-8c0b-8d52e48072bb',
    arcade: 'https://html5games.com/Arcade/ecfe76c8-13f9-49c1-b81a-084011512dba',
    racing: 'https://html5games.com/Racing/b53dc097-05cd-457f-a811-e0c6c47ca37a',
    sport: 'https://html5games.com/Sport/92ab9ee5-0dc8-45b4-bf5a-517fc3de0caf',
};

function IframeDisplay({ category }) {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');
    const mainSectionRef = useRef(null); // Create a reference for the div

    useEffect(() => {
        setIframeUrl(categoryUrls[category] || 'https://html5games.com/default');
    }, [category]);

    useEffect(() => {
        // Log the element with the "main-section" class
        if (mainSectionRef.current) {
            console.log('Main Section Div:', mainSectionRef.current);
        }
    }, [mainSectionRef]);

    const toggleFullScreen = () => {
        setIsFullScreen((prev) => !prev);
    };

    return (
        <Box
            ref={mainSectionRef} // Attach the ref to the Box element
            className="main-section" // Assign the class for targeting
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: isFullScreen ? '100vh' : 'auto',
                backgroundColor: '#f4f6f8',
                padding: isFullScreen ? 0 : 2,
                position: isFullScreen ? 'fixed' : 'relative',
                top: 0,
                left: 0,
                width: '100%',
                zIndex: isFullScreen ? 9999 : 'auto',
            }}
        >
            {!isFullScreen && (
                <Typography variant="h4" gutterBottom sx={{ marginTop: 5 }}>
                    {category.replace(/-/g, ' ').toUpperCase()}
                </Typography>
            )}
            <Paper
                elevation={3}
                sx={{
                    width: isFullScreen ? '100%' : '100%',
                    maxWidth: isFullScreen ? '100%' : '1200px',
                    height: isFullScreen ? '100vh' : '80vh',
                    borderRadius: isFullScreen ? 0 : 2,
                    overflow: 'hidden',
                }}
            >
                <iframe
                    src={iframeUrl}
                    title={category}
                    className="main-section" // Class for iframe
                    width="100%"
                    height="100%"
                    style={{
                        border: 'none',
                    }}
                />
            </Paper>
            <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={toggleFullScreen}
                    sx={{ margin: 1 }}
                >
                    {isFullScreen ? 'Close Full Screen' : 'Full Screen'}
                </Button>
            </Box>
        </Box>
    );
}

export default IframeDisplay;
